import { useEffect, useRef } from "react";
export const useAutofocusRef = (isActive) => {
    const ref = useRef(null);
    useEffect(() => {
        const inputElement = ref.current;
        if (!isActive || !inputElement)
            return;
        // Using setTimeout trick ensure focus can move from the trigger button to the input
        // since React may not have fully committed and rendered the popover DOM nodes yet.
        // Alternative: using requestAnimationFrame but it gives unstable behaviors.
        const timeoutId = setTimeout(() => {
            inputElement.focus({
                preventScroll: true,
            });
        }, 100);
        return () => {
            clearTimeout(timeoutId);
        };
    }, [isActive]);
    return ref;
};
